var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"dialog",attrs:{"title":_vm.title,"width":"80%","visible":_vm.is_visible,"close-on-click-modal":true},on:{"update:visible":function($event){_vm.is_visible=$event},"close":function($event){return _vm.$emit('reset-callback')}}},[_c('div',{staticClass:"full-resume",domProps:{"innerHTML":_vm._s(_vm.formattedResume)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }